// Values taken from FBMOrderIngestResultsModel.php in ecommerce
// TOOD: Potentially control this list via an endpoint?
/** @type {{ value: string, label: string }[]} */
export const INGEST_RESULT_TYPE_FILTER_OPTIONS = [
    { value: 'success', label: 'Success' },
    { value: 'deferred', label: 'Deferred' },
    { value: 'shopify_error', label: 'Shopify error' },
    { value: 'no_line_haul', label: 'No line haul' },
    { value: 'invalid_address', label: 'Invalid address' },
    { value: 'no_zip_mapping', label: 'No zip mapping' },
    { value: 'invalid_item', label: 'Invalid item' },
    { value: 'unknown_item', label: 'Unknown item' },
];
